<template>
  <booking-section id="leadForm" :title="`Ihr Reiseangebot`" contentClass="">
    <template v-if="loaded">
      <div class="booking-element">
        <h3>{{ productName }}</h3>

        <div class="row">
          <div class="column small-12 large-8">
            <div class="spacer" v-html="introText" />
            <div class="row">
              <div class="column small-12 large-6">
                <a class="cta cta--dark cta--inline" @click="sendBookingProceed()">Direkt verbindlich buchen</a>
              </div>
              <div class="column small-12 large-6">
                <a class="cta cta--inline" @click="customerChoiceOffer()">Unverbindlich reservieren</a>
              </div>
            </div>
          </div>
          <div class="column small-12 large-4">
            <img :src="introPicture">
          </div>
        </div>
      </div>
      <template v-if="offerMode">
        <div class="booking-element" :class="{'booking-error': hasErrors }">
          <label><b>Ihre Daten</b></label>
          <div class="row">
            <div class="column small-12 large-2">
              <label>Anrede</label>
              <select2 v-model="form.gender" :options="genderSelect" :settings="{ placeholder: 'Bitte wählen Sie:', dropdownCssClass: 'dropdown-shadow' }">
              </select2>
            </div>
            <div class="column small-12 large-5">
              <label>Vorname*</label>
              <input class="underline" type="text" v-model="form.first_name"/>
              <booking-element-error type="error" :msg="msg" :key="i" v-for="(msg) in errors['first_name']" v-if="errors['first_name']" />
            </div>
            <div class="column small-12 large-5">
              <label>Nachname*</label>
              <input class="underline" type="text" v-model="form.last_name"/>
              <booking-element-error type="error" :msg="msg" :key="i" v-for="(msg) in errors['last_name']" v-if="errors['last_name']" />
            </div>
            <div class="column small-12 large-4">
              <label>E-Mail*</label>
              <input class="underline" type="text" v-model="form.email"/>
              <booking-element-error type="error" :msg="msg" :key="i" v-for="(msg) in errors['email']" v-if="errors['email']" />
            </div>
            <div class="column small-12 large-4">
              <label>Telefonnummer*</label>
              <input class="underline" type="text" v-model="form.phone"/>
              <booking-element-error type="error" :msg="msg" :key="i" v-for="(msg) in errors['phone']" v-if="errors['phone']" />
            </div>
            <div class="column small-12 large-4">
              <label>Ort</label>
              <input class="underline" type="text" v-model="form.city"/>
            </div>
          </div>
        </div>
        <div class="booking-element" :class="{'booking-error': hasErrors }">
          <label><b>Rückrufbitte/Kontaktaufname</b></label>
          <div class="row">
            <div class="column small-12 large-4">
              <label>Rückrufbitte:</label>
              <select2 v-model="form.callback_time" :options="[{id: 0, text: 'schnellstmöglich'}, {id: 1, text: 'Gewünschter Zeitraum'}]" :settings="{ placeholder: 'Bitte wählen Sie:', dropdownCssClass: 'dropdown-shadow' }">
              </select2>
              <booking-element-error type="error" :msg="msg" :key="i" v-for="(msg) in errors['callback_time']" v-if="errors['callback_time']" />
            </div>
            <div class="column small-12 large-6">
              <label>Anmerkung zur Kontaktaufname:</label>
              <input class="underline" type="text" v-model="form.callback_comment"/>

              <template v-if="form.callback_time == 1">
                <label>Gewünschter Zeitpunkt:</label>
                <input class="underline" type="text" v-model="form.callback_info"/>
                <booking-element-error type="error" :msg="msg" :key="i" v-for="(msg) in errors['callback_info']" v-if="errors['callback_info']" />
                <div v-html="callbackDetailsText" />
              </template>
            </div>
            <div class="column small-12 large-12">
              <div v-html="callbackText" />
            </div>
          </div>
        </div>
        <div class="booking-element"  :class="{'booking-error': hasErrors }">
          <label>
            <b>Weitere Services</b><b v-if="hasFlight">/Flugreservierung</b>
          </label>
          <div class="row">
            <div class="column small-12 large-12">
              <label>Gewünschte Serviceleistungen (Mehrfachauswahl):</label>
              <select2 v-model="form.services" :options="mappedServiceOptions" :settings="{ placeholder: 'Bitte wählen Sie:', dropdownCssClass: 'dropdown-shadow', multiple: true }" />
            </div>
          </div>
          <div class="row spacer" v-if="hasFlight">
            <div class="column small-12 large-12">
              <div  @click="form.flightReservationRequested = !form.flightReservationRequested"><input type="checkbox" v-model="form.flightReservationRequested"></input><label>Flugreservierung gewünscht</label></div>
              <div v-html="flightText" v-if="form.flightReservationRequested" />
              <div v-html="noFlightReservationText" v-else />
              <booking-element-error type="error" :msg="msg" :key="i" v-for="(msg) in errors['travelling_persons']" v-if="errors['travelling_persons'] && form.flightReservationRequested" />
            </div>
            <div class="column small-12 large-12" v-if="form.flightReservationRequested" v-for="(f, i)  in flightPersonsRequired">

              <div class="row" :class="{'booking-error': form.travellingPersons[i].error }">
                <div class="column small-12 large-12">
                  <label>{{i+1}}. Person</label>
                </div>
                <div class="column small-12 large-2">
                  <label>Anrede*</label>
                  <select2 v-model="form.travellingPersons[i].gender" :options="genderSelect" :settings="{ placeholder: 'Bitte wählen Sie:', dropdownCssClass: 'dropdown-shadow' }">
                  </select2>
                </div>
                <div class="column small-12 large-4">
                  <label>Vorname*</label>
                  <input class="underline" type="text" v-model="form.travellingPersons[i].first_name"/>

                </div>
                <div class="column small-12 large-3">
                  <label>Nachname*</label>
                  <input class="underline" type="text" v-model="form.travellingPersons[i].last_name"/>
                </div>
                <div class="column small-12 large-3">
                  <label>Geb.datum*</label>
                  <input class="underline" type="date" v-model="form.travellingPersons[i].date_of_birth"/>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="booking-element"  :class="{'booking-error': false }">

          <div  @click="form.privacyCheck = !form.privacyCheck">
            <input type="checkbox" v-model="form.privacyCheck"></input>
            <label>Mit dem Absenden des Formulars bestätige ich, die <a href="/de/datenschutz" target="_blank">Datenschutzerklärungen von Luxurydreams</a> gelesen, verstanden und aktzepiert zu haben.</label>
          </div>

          <div class="text-center">
            <a class="cta cta--inline" @click="submitOfferRequest()">Reisewunsch absenden</a>
          </div>
        </div>
      </template>
    </template>

    <loader v-else title="Ihre Buchung wird vorbereitet" details="Einen Moment bitte"></loader>
  </booking-section>
</template>

<script>

import axios from 'axios'
import resultLoader from '../booking/mixins/resultLoader'
import bookingDefaults from '../booking/mixins/bookingDefaults'
import checkout from '../booking/mixins/checkout'


export default {
  mixins: [resultLoader, bookingDefaults, checkout],
  data(){
    return {
      introText: null,
      introPicture: null,
      flightText: null,
      callbackText: null,
      pictureUrl: null,
      productName: null,
      noFlightReservationText: null,
      callbackDetailsText:null,
      serviceOptions: [],
      currentStep: 'leadForm',
      hasErrors: false,
      offerMode: false,
      errors: {},
      form: {
        gender: null,
        first_name: null,
        last_name: null,
        email: null,
        phone: '',
        services: [],
        callback_time: null,
        callback_info: null,
        callback_comment: null,
        privacyCheck: false,
        flightReservationRequested: true,
        travellingPersons: [{},{},{},{},{},{},{},{},{},{}]
      },
      genderSelect: [{id: true, text: 'Herr'}, {id: false, text: 'Frau'}],

    }
  },
  mounted(){
    axios.get(this.apiUrl('lead_form'))
    .then(response => {
      this.introText     = response.data.intro_text
      this.introPicture  = response.data.intro_picture
      this.flightText    = response.data.flight_text
      this.noFlightReservationText = response.data.no_flight_reservation_text
      this.callbackText  = response.data.callback_text
      this.callbackDetailsText = response.data.callback_details_text
      this.serviceOptions     = response.data.service_options
      this.pictureUrl = response.data.picture_url
      this.productName = response.data.product_name
      this.loaded = true

    })
  },
  computed: {
    mappedServiceOptions(){
      return this.serviceOptions.map(s => ({id: s, text: s}))
    },
    hasFlight(){
      return this.result.calculation_data.length && this.result.calculation_data[0].flight_proposal_id
    },
    flightPersonsRequired(){
      var c = 0
      this.result.calculation_data.forEach(r => {
        c = c + r.calculated_persons_count
      })
      return c
    },
    getOfferTag(){
      if (this.form.flightReservationRequested){
        return 'GetOfferWithReservation'
      }else{
        return 'GetOffer'
      }
    }
  },

  methods: {
    customerChoiceBooking(){
      this.gTrack(`${this.currentStep}:CreateBooking`)
      this.sendBookingProceed()
    },
    customerChoiceOffer(){
      this.gTrack(`${this.currentStep}:GetOffer`)
      this.offerMode = true
    },
    submitOfferRequest(){
      if (this.form.privacyCheck){
        this.loaded = false
        axios.post(this.apiUrl('send_lead_form'), {data: this.form, calculation_data: JSON.stringify(this.result.calculation_data), price_summary: this.result.global })
        .then(response => {
          if (response.data.status == 'OK'){
            this.gTrack(`${this.currentStep}:${this.getOfferTag}:Success`)
            window.location = response.data.url
          }else{
            this.gTrack(`${this.currentStep}:${this.getOfferTag}:Errors`)
            this.loaded = true
            this.hasErrors = true
            this.errors = response.data.errors
          }
        })
        .catch(_ => {
          this.loaded = true
        })
      }else{
        alert("Bitte akzeptieren Sie die Datenschutzerklärungen")
      }
    },
    recalculate(){
      this.reloading = true
      axios.post(`${process.env.BASE_URL}/api/booking/${this.productId}/recalculate`, {
        calculation_data: JSON.stringify(this.result.calculation_data)
      })
      .then(response => {
        this.pricesTable = response.data.prices_table
        this.price = response.data.results[0].price_display
        this.$emit('update-summary', response.data)
        this.reloading = false
      })
    },
  }
}

</script>
